import logo from './logo.svg';
import './App.css';
import { Route, Router, Routes } from 'react-router-dom';
import User from './Components/User';
import Header from './Components/Header';
import Login from './Components/Login';
import Contact from './Components/Contact';
import Index from './Components/Index';
import Singlepage from './Components/Home Pages/singlepage';
import About from './Components/About';
import MarketUpdate from './Components/Market/market';
import BuyCrypto from './Components/Market/buyCryptoCoin';
import SellBuyCrypto from './Components/Market/sellBuyCrypto';
import FAQ from './Components/FAQ';
import PageNotFound from './Components/404';
import Blog from './Components/Blog';
import BlogDetail from './Components/Blog Details';
import BlogDetailLeft from './Components/BlogDetailsLeft';
import BlogDetailRight from './Components/BlogDetailsRight';
import Register from './Components/Register';
import MultiHomepage from './Components/Home2/mul';
import SingleHomepage from './Components/Home2/single';
import SingleHome2pages from './Components/Home3/single';
import SingleIndexHomepages from './Components/Home4/single';
import MultiIndexHomePages from './Components/Home4/mul';
import MultiHomePages from './Components/Home3/mul';

function App() {
  return (
    <>
      {/* <Header /> */}
      <Routes>
        <Route path='/' element={<Index />} />
        <Route path='/user' element={<User />} />
        <Route path='/login' element={<Login />} />
        <Route path='/register' element={<Register />} />
        <Route path='/contact' element={<Contact />} />
        <Route path='/singlePage' element={<Singlepage />} />
        <Route path='/about' element={<About />} />
        <Route path='/market' element={<MarketUpdate />} />
        <Route path='/buyCrypto' element={<BuyCrypto />} />
        <Route path='/sellBuyCrypto' element={<SellBuyCrypto />} />
        <Route path='/faq' element={<FAQ />} />
        <Route path='/error' element={<PageNotFound />} />
        <Route path='/blog' element={<Blog />} />
        <Route path='/blogDetail' element={<BlogDetail />} />
        <Route path='/blogDetailLeft' element={<BlogDetailLeft />} />
        <Route path='/blogDetailRight' element={<BlogDetailRight />} />
        <Route path='/homeSinglePage' element={<SingleHomepage />} /> { /*home 2 */}
        <Route path='/homeMultipage' element={<MultiHomepage />} />{ /*home 2 */}
        <Route path='/home2SinglePage' element={<SingleHome2pages />} /> { /*home 3 */}
        <Route path='/home2MultiPage' element={<MultiHomePages />} /> { /*home 3 */}
        <Route path='/homeIndexSinglePage' element={<SingleIndexHomepages/>} /> { /*home 4 */}
        <Route path='/homeIndexMultiPage' element={<MultiIndexHomePages />} /> { /*home 4 */}


      </Routes>
    </>
  );
}

export default App;
